import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'gatsby';
import { fcw, drowsy } from '/src/videos';

const RoadSafety = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.road-safety' });

	return (
		<section className="road-safety">
			<div className="content-wrapper">
				<h3>{t('amplifying-your-phone')}</h3>

				<div className="row-container">
					<div className="feature-row">
						<aside>
							<div className="tag-wrapper">
								<strong className="green">{t('premium')}</strong>
								{/* <strong className="yellow">{t('labs')}</strong> */}
							</div>

							<h4>{t('forward-collision-warnings')}</h4>
							<p>{t('benefit-from-latest')}</p>

							<Link to="/intelligent-safety">
								<button>{t('learn-more-about-safety-features')}</button>
							</Link>
						</aside>

						<video playsInline autoPlay loop muted>
							<source src={fcw} type="video/mp4" />
						</video>
					</div>

					<div className="feature-row">
						<aside>
							<div className="tag-wrapper">
								{/* <strong className="green">{t('premium')}</strong> */}
								<strong className="yellow">{t('labs')}</strong>
							</div>

							<h4>{t('drowsy-driving-alerts')}</h4>
							<p>{t('ensuring-that-you')}</p>
						</aside>

						<video playsInline autoPlay loop muted>
							<source src={drowsy} type="video/mp4" />
						</video>
					</div>
				</div>
			</div>
		</section>
	);
};

export default RoadSafety;
